import { render, staticRenderFns } from "./vip.vue?vue&type=template&id=3937dd08&scoped=true"
import script from "./vip.vue?vue&type=script&lang=js"
export * from "./vip.vue?vue&type=script&lang=js"
import style0 from "./vip.vue?vue&type=style&index=0&id=3937dd08&prod&lang=css"
import style1 from "./vip.vue?vue&type=style&index=1&id=3937dd08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3937dd08",
  null
  
)

export default component.exports